// extracted by mini-css-extract-plugin
export default {"body":"Payment_body__4fdFf","dataMap":"Payment_dataMap__b+ZUb"};